<div class="gacha-content">
  <div>
    <h2 class="confirm title header-text heavy-header-text" mat-dialog-title>
      Choose your avatar!
    </h2>
    <mat-dialog-content>
      <p>
        Would you like to update your displayed avatar for just 5 sand dollars?
      </p>
      <div class="row justify-start align-items-centered">
        <img
          class="coin"
          src="/assets/img/coin/coin_purse.png"
          alt="Image of coin in the shape of a sand dollar"
        />
        <h2 class="confirm title header-text heavy-header-text">&Phi; 5</h2>
      </div>
      <div class="avatar-collection">
        <ng-container *ngFor="let critter of critters">
          <label>
            <input
              type="radio"
              name="critter"
              [value]="critter.id"
              [formControl]="selectedCritter"
              [attr.disabled]="disableOption(critter)"
            />
            <img [src]="critter.avatarImage.signedUrl" alt="" />
          </label>
        </ng-container>
      </div>
    </mat-dialog-content>
  </div>
  <mat-dialog-actions class="centered">
    <h2 *ngIf="!enoughCoins" class="confirm">
      You do not have enough sand dollars!
    </h2>

    <app-confirm-cancel
      [buttonConfig]="buttonConfig"
      [disableSubmit]="submitDisabled"
      (emitSubmit)="submit()"
    >
    </app-confirm-cancel>
  </mat-dialog-actions>
</div>
